import { render, staticRenderFns } from "./ComponentRodape.vue?vue&type=template&id=6681522e&scoped=true&"
import script from "./ComponentRodape.vue?vue&type=script&lang=js&"
export * from "./ComponentRodape.vue?vue&type=script&lang=js&"
import style0 from "./ComponentRodape.vue?vue&type=style&index=0&id=6681522e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6681522e",
  null
  
)

export default component.exports